<template>
	<div class="yuu" ref="yuu">
		<el-row>
			<el-col :span="1" style="color:transparent">1</el-col>
			<el-col :span="7" class="title">
				<span>方案名称 :</span>
				<el-input type="text" size="mini" v-model="percwinfo.c_name" @input="changeinput" style="width:250px;"></el-input>
			</el-col>
			<el-col :span="16" class="title">
				<span>备注 :</span>
				<el-input type="text" size="mini" v-model="percwinfo.remark" @input="changeinput" style="max-width:400px;"></el-input>
			</el-col>
		</el-row>
		<div ref="freightlist" :style="{ height: `${windowHeight}px`, 'overflow-y': 'auto' }">
			<el-card class="box-card" label="" :key="index" v-for="(item,index) in freightlist">
				<div slot="header" class="clearfix">
					<span>渠道：</span>
					<el-select v-model="item.p_mode" placeholder="请选择渠道" size="mini" style="width:200px">
						<el-option v-for="p in p_modes" :key="p.d_name" :label="p.d_name" :value="p.d_name"></el-option>
					</el-select>
					<i class="el-icon-delete" style="color:red;margin-left:10px;" title="移除板块" @click="delchunk(index)"></i>
				</div>
				<table class="tablecss" cellspacing="0">
					<tr v-for="(chunk, i) in item.feelist">
						<td valign="top">
							<table class="weightrange" cellspacing="0">
								<thead>
									<td class="td1">总价区间</td>
									<td class="td2">含税费用</td>
									<td class="td3">税率(%)</td>
									<td class="td4"></td>
								</thead>
								<tbody>
									<tr v-for="(range,rindex) in chunk.weightrange">
										<td class="td1">
											<el-row>
												<el-col :span="5"><el-input type="text" size="mini" v-model="range.b_weight" @input="changeinput" ></el-input></el-col>
												<el-col :span="2" style="text-align:center;"><span>-</span></el-col>
												<el-col :span="5"><el-input type="text" size="mini" v-model="range.e_weight" @input="changeinput"></el-input></el-col>
											</el-row>
										</td>
										<td class="td2"><el-input type="text" size="mini" v-model="range.s_price" @input="changeinput"></el-input></td>
										<td class="td3"><el-input type="text" size="mini" v-model="range.province" @input="changeinput"></el-input></td>
										<td class="td4"><i class="el-icon-delete" style="color:red" @click="delweightrange(rindex,chunk.weightrange,i,item.feelist)"></i></td>
									</tr>
									<tr>
										<td colspan="7" class="addrange"><el-button type="warning" size="mini" @click="addweightrange(i,index)">添加区间费用</el-button></td>
									</tr>
								</tbody>
							</table>
						</td>
					</tr>
				</table>
			</el-card>
			<div class="addpmode"><el-button type="primary" size="small" @click="addpmode()" icon="el-icon-circle-plus-outline">添加渠道设置</el-button></div>
		</div>
		<el-row class="footerhandler">
			<el-col :span="4" class="submitBtn_switch" style="color:transparent;">1</el-col>
			<el-col :span="5" class="submitBtn"><div @click="saverule">保存</div></el-col>
			<el-col :span="1" style="color:transparent">1</el-col>
			<el-col :span="6" class="cancelBtn"><div @click="rebacksetscheme">返回</div></el-col>
			<el-col :span="7" class="submitBtn_switch"></el-col>
		</el-row>
	</div>
</template>
<script>
import tableui from '@/components/table/tablegrid.vue';
import Utils from '../../lib/util.js';
export default {
	components: {
		tableui
	},
	props: {},
	data() {
		return {
			isedit: false,
			ischange:false,
			percwinfo: {
				c_id: '',
				c_name: '',
				remark:'',
				p_type:'区间固定运费'
			},
			windowHeight: window.innerHeight - 200,
			p_modes: [],
			freightlist: [],
			emptyfreight: [
				{
					p_mode: '',
					feelist: [
						{
							weightrange: [{ b_weight: '', e_weight: '', s_price: '',province:''}]
						}
					]
				}
			]
		};
	},
	mounted() {
		this.$apipost.get.getTheme().then(res => {
			import('../../static/' + res + '/style/cw/rangeadded.scss');
		});
	},
	methods: {
		init(param) {
			if (param != '' && param != undefined) {
				this.p_name = param.p_name;
				if (param.percwinfo != undefined) {
					if (param.percwinfo.c_id != undefined) this.percwinfo.c_id = param.percwinfo.c_id;
					if (param.percwinfo.c_name != undefined) this.percwinfo.c_name = param.percwinfo.c_name;
					if (param.percwinfo.remark != undefined) this.percwinfo.remark = param.percwinfo.remark;
				}
				if(this.percwinfo.c_id==undefined||this.percwinfo.c_id==''){
					this.percwinfo ={c_name:'',
					remark:'',
					c_id:'',p_type:'区间固定运费'};
					this.freightlist=JSON.parse(JSON.stringify(this.emptyfreight));
					this.ischange = false;
				}
				this.isedit = param.isedit;
				this.loadbaseoption();
			}
		},
		GetCurrentscheme() {
			var that = this;
			if (this.percwinfo.c_id != '' && this.percwinfo.c_id != undefined) {
				var paraminfo = {
					c_id: this.percwinfo.c_id,
					ismain: 0
				};
				this.$tool.loading('正在加载', 'yuu');
				this.$apipost.get.Getscheme({ paraminfo: paraminfo }).then(res => {
					this.$tool.loadingclose();
					if (res != '') {
						//console.log('方案详情',res);
						if (res.freightlist != undefined) {
							if (res.freightlist.length > 0) {
								//debugger
								var pmodes=[];
								res.freightlist.forEach(e=>{
									var count=pmodes.filter(function(item) {
										return item.p_mode==e.p_mode;
									});
									if(count==0)
										pmodes.push({p_mode:e.p_mode});
								});
								var list=[];
								pmodes.forEach(e=>{
									var range=res.freightlist.filter(function(item){return item.p_mode==e.p_mode;});
									list.push({p_mode:e.p_mode,
									feelist:[{weightrange:range}]});
								});
								that.freightlist =list;
							} else {
								that.freightlist = JSON.parse(JSON.stringify(that.emptyfreight));
							}
						}
					}
				});
			}
		},
		//保存财务方案
		saverule() {
			var that = this;
			var paraminfo=[{
				c_id: this.percwinfo.c_id,
				c_name: this.percwinfo.c_name,
				remark: this.percwinfo.remark,
				p_type: this.percwinfo.p_type,
				userid:localStorage.getItem('userid'),
				freightlist:this.freightlist
			}]
			// console.log('paraminfo',JSON.stringify(paraminfo));
			// if(1>0) return false;
			this.$tool.loading('正在保存', 'yuu');
			this.$apipost.post.Savescheme({ paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if (res.state == '1') {
					this.$tool.message('保存成功', 1);
					that.ischange = false;
					that.rebacksetscheme();
				} else {
					this.$tool.alertmessage(res.message);
				}
			});	
		},
		addweightrange(i,index) {
			var item=JSON.parse(JSON.stringify(this.emptyfreight[0].feelist[0].weightrange[0]));
			this.freightlist[index].feelist[i].weightrange=this.freightlist[index].feelist[i].weightrange.concat(item);
		},
		addrule(index) {
			var item=JSON.parse(JSON.stringify(this.emptyfreight[0].feelist[0]));
			this.freightlist[index].feelist=this.freightlist[index].feelist.concat(item);
		},
		addpmode() {
			var item=JSON.parse(JSON.stringify(this.emptyfreight[0]));
			this.freightlist=this.freightlist.concat(item);
			//滚动条滚到底
			this.$nextTick(() => {
				this.$refs.freightlist.scrollTop = this.$refs.freightlist.scrollHeight;
			});
		},
		delchunk(index) {
			this.freightlist.splice(index,1);
		},
		delweightrange(rindex,item,index,ruleitem){
			item.splice(rindex,1);
			if(item.length==0){
				this.delrule(index,ruleitem);
			}
		},
		delrule(i,item,index){
			item.splice(i,1);
			if(item.length==0)
				this.delchunk(index);
		},
		loadbaseoption(){
			var that=this;
			//获取权限内的渠道
			this.$apipost.get.GetClarance().then(res => {
				that.p_modes = res.list;
				//获取方案信息
				that.GetCurrentscheme();
			});
			//获取分类
			// this.$apipost.get.GetSort({pid:0}).then(res => {
			// 	that.sorts=res.list;
			// });
			//获取进位规则

		},
		//返回
		rebacksetscheme() {
			if (this.ischange) {
				this.$confirm('您的信息有更改，确定放弃保存吗?', '提示', {
					confirmButtonText: '放弃',
					cancelButtonText: '取消',
					type: 'warning',
					closeOnClickModal: false
				}).then(() => {
					this.$emit('reback', {});
				});
			} else {
				this.$emit('reback', {});
			}
		},
		//文本框改变
		changeinput() {
			this.ischange = true;
		}
	}
};
</script>

<style></style>
